<style lang="less">
.dcGiveItem {
  +.dcGiveItem {
    border-top: 1px solid #dddddd;
  }
  &__logo,
  &__info {
    position: relative;
    top: 0;
    left: 0;
    height: 1rem;
  }

  &__logo {
    &::after {
      content: ' ';
      display: block;
      position: absolute;
      top: -2px;
      width: 100%;
      height: 4px;
      background: #fff;
      font-size: 1px;
    }
    .k-user-logo {
      position: absolute;
      top: 0.15rem;
      left: 0;
      width: 0.64rem;
      height: 0.64rem;
    }
  }
  &__info {
    font-size: 0.24rem;
    line-height: 1.5;
    dl,
    dd {
      margin: 0;
      padding: 0;
    }
    dt {
      margin: 0;
      padding: 0.1rem 0 0;
    }
  }

  &__stOrBtn {
    padding: 0.2rem 0 0;
    text-align: center;
    .k-button {
      background-image: linear-gradient(270deg, #c7a862 0%, #f8efbc 100%);
      box-shadow: inset 0 0.03rem 0.06rem 0 rgba(248, 247, 242, 0.5);
      border-radius: 0.36rem;
      line-height: 0.56rem;
      height: 0.56rem;
      border-width: none;
    }
    .k-button--danger {
      color: #fff;
      background-color: none;
      border: none;
      color: #000;
    }
  }
  &__status {
    text-align: center;
    padding: 0.1rem 0 0;
    font-size: 0.24rem;
  }
}
</style>
<template>
  <div class="dcGiveItem">
    <k-row v-if="takeUser">
      <k-col span="3" class="dcGiveItem__logo"
        ><k-user-logo
          v-if="takeUser"
          :src="takeUser.logoSm"
          :lv="takeUser.lvKey"
          size="small"
      /></k-col>
      <k-col span="16" class="dcGiveItem__info">
        <dl>
          <dt>编码: {{ item.id }}</dt>
          <dd>{{takeUser.nick}} 领取</dd>
        </dl>
      </k-col>
      <k-col span="5" class="dcGiveItem__stOrBtn">
        <div v-if="item.awardStatus > 0" class="dcGiveItem__status">权限已发放</div>
        <div v-else class="dcGiveItem__status">待发放</div>
      </k-col>
    </k-row>
    <k-row v-else>
      <k-col span="3" class="dcGiveItem__logo"
        ><k-user-logo src="https://imgcdn-prd.pydp888.com/file/0/1/200003/20201028/46d4a35ab225281913d2eb94399e0f80.4_wenhao.png" lv="user" size="small"
      /></k-col>
      <k-col span="16" class="dcGiveItem__info">
        <dl>
          <dt>编码: {{ item.id }}</dt>
          <dd>只能赠送给非王者财经用户</dd>
        </dl>
      </k-col>
      <k-col span="5" class="dcGiveItem__stOrBtn">
        <router-link :to="`/dc/award?c=${item.id}`"><k-button block type="danger" size="small">赠送</k-button></router-link>
      </k-col>
    </k-row>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: ['item'],
  computed: {
    ...mapGetters('laxin', ['getUser']),
    giveUser() {
      return this.getUser(this.item.gUid)
    },
    takeUser() {
      return this.getUser(this.item.takeUid)
    }
  }
}
</script>
